<template>
  <div>
    <PageHead title="公务用车申请"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">用车部门：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.organization_id"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">申请事由：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入事由"
                v-model="queryForm.reason"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">用车人员：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入经办人"
                v-model="queryForm.agent"
              />
            </div>
          </div>
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">用车时间：</div>
              <a-range-picker
                allowClear
                class="w200"
                v-model="timeHorizon"
                :valueFormat="dateFormat"
              >
                <a-icon slot="schedule" type="smile"
              /></a-range-picker>
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待提交</a-select-option>
                <a-select-option :value="1">正在审批</a-select-option>
                <a-select-option :value="2">已归档</a-select-option>
                <a-select-option :value="3">退回</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" :loading="loading" @click="subMit">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns">
        <a-button type="primary" @click="goDetial()" icon="plus">
          申请</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="time" slot-scope="text, record">
          {{ record.starttime }}~ {{ record.endtime }}
        </span>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 1)"
          >
            查看
          </a-button>
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button>
          </template>
          <a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },
  {
    title: '用车部门',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '用车人员',
    dataIndex: 'agent',
    key: 'agent',
    ellipsis: true
  },

  {
    title: '申请事由',
    dataIndex: 'reason',
    key: 'reason',
    ellipsis: true
  },
  {
    title: '用车时间',
    dataIndex: 'time',
    key: 'time',
    scopedSlots: { customRender: 'time' },
    ellipsis: true
  },
  {
    title: '去往地点',
    dataIndex: 'place',
    key: 'place',
    ellipsis: true
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { getTheCarApplication, delTheCarApplication } from './api/api'
import { mapState, mapActions } from 'vuex'
import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      dateFormat: 'YYYY-MM-DD',
      timeHorizon: [], //时间范围
      loading: false
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  created() {
    this.getorganizeListFn()
    this.load()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'the-car-application')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.load()
        })
        .catch((error) => {
          console.log(error)
          this.load()
        })
    },
    ...mapActions(['getorganizeListFn']),
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        params.starttime = this.timeHorizon[0]
        params.endtime = this.timeHorizon[1]
      } else {
        delete params.starttime
        delete params.endtime
      }
      getTheCarApplication(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delTheCarApplication({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id, type) {
      if (type) {
        this.$router.push('/ApplicationForVehicleDetial?id=' + id + '&isEdit=1')
      } else {
        if (id) {
          this.$router.push('/ApplicationForVehicleDetial?id=' + id)
        } else {
          this.$router.push('/ApplicationForVehicleDetial')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.timeHorizon = []
    },
    subMit() {
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForVehicle/index.vue